import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//componente ui:
import DatePicker from '../../utils/DatePicker';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { Tooltip, Fade } from '@material-ui/core';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '30px 0 0 25px',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: 'white',
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class EditContabCentro extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.contabCentro.id
                ? this.props.contabCentro.id
                : uuidv4(),
            iTipoMaquina: this.props.contabCentro.iTipoMaquina
                ? this.props.contabCentro.iTipoMaquina
                : this.props.tiposMaquina[0].id,
            tipoMaquina: this.props.contabCentro.tipoMaquina
                ? this.props.contabCentro.tipoMaquina
                : this.props.tiposMaquina[0].descr,
            zonaIva: this.props.contabCentro.zonaIva
                ? this.props.contabCentro.zonaIva
                : this.props.tiposZonaIva[0].descr,
            iTipoZonaIva: this.props.contabCentro.iTipoZonaIva
                ? this.props.contabCentro.iTipoZonaIva
                : this.props.tiposZonaIva[0].id,
            ctaDebe: this.props.contabCentro.ctaDebe
                ? this.props.contabCentro.ctaDebe
                : '',
            ctaHaber: this.props.contabCentro.ctaHaber
                ? this.props.contabCentro.ctaHaber
                : '',
            ctaIva: this.props.contabCentro.ctaIva
                ? this.props.contabCentro.ctaIva
                : '',
            fIni: this.props.contabCentro.fIni
                ? this.props.contabCentro.fIni.slice(0, 10)
                : new Date().toJSON().slice(0, 10),
            fEnd: this.props.contabCentro.fEnd
                ? this.props.contabCentro.fEnd.slice(0, 10)
                : null,
        };
    }

    fillSelectMaquina = () =>
        this.props.tiposMaquina.map(t => (
            <option key={t.id} value={t.id}>
                {t.descr}
            </option>
        ));

    fillSelectIva = () =>
        this.props.tiposZonaIva.map(tzi => (
            <option key={tzi.id} value={tzi.id}>
                {tzi.descr}
            </option>
        ));

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    handleSelectChange = (event, field) => {
        const value = parseInt(event.target.value);

        if (field === 'tipoMaquina') {
            this.setState({
                iTipoMaquina: value,
                tipoMaquina: this.props.tiposMaquina.find(t => t.id === value)
                    .descr,
            });
        } else if (field === 'zonaIva') {
            this.setState({
                iTipoZonaIva: value,
                zonaIva: this.props.tiposZonaIva.find(tzi => tzi.id === value)
                    .descr,
            });
        }
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="tipos-maquina-placeholder">
                            Tipos de Maquina
                        </InputLabel>
                        <Select
                            native
                            value={this.state.iTipoMaquina}
                            onChange={event =>
                                this.handleSelectChange(event, 'tipoMaquina')
                            }
                            name="tipoMaquina"
                        >
                            {this.fillSelectMaquina()}
                        </Select>
                    </FormControl>

                    <Tooltip
                        title="Zona de IVA que ofrece a cada tipo de máquina"
                        TransitionComponent={Fade}
                        TransitionProps={{ timeout: 600 }}
                        classes={{ tooltip: this.props.classes.tooltip }}
                    >
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="tipos-zona-iva-placeholder">
                                Tipo de Zona Iva
                            </InputLabel>
                            <Select
                                native
                                value={this.state.iTipoZonaIva}
                                onChange={event =>
                                    this.handleSelectChange(event, 'zonaIva')
                                }
                                name="zonaIva"
                            >
                                {this.fillSelectIva()}
                            </Select>
                        </FormControl>
                    </Tooltip>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <Tooltip
                            title="Cuenta corriente asociado a este tipo de maquina en este centro"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            <TextField
                                id={'ctaDebe'}
                                label={'Cuenta Debe'}
                                placeholder={'Cuenta Debe'}
                                value={this.state.ctaDebe}
                                onChange={event =>
                                    this.handleValueChange(event, 'ctaDebe')
                                }
                            />
                        </Tooltip>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <Tooltip
                            title="Cuenta corriente asociado a este tipo de maquina en este centro"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            <TextField
                                id={'ctaHaber'}
                                label={'Cuenta Haber'}
                                placeholder={'Cuenta Haber'}
                                value={this.state.ctaHaber}
                                onChange={event =>
                                    this.handleValueChange(event, 'ctaHaber')
                                }
                            />
                        </Tooltip>
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <Tooltip
                            title="Cuenta corriente asociada al IVA para este tipo de máquina"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            <TextField
                                id={'ctaIva'}
                                label={'Cuenta Iva'}
                                placeholder={'Cuenta IVA'}
                                value={this.state.ctaIva}
                                onChange={event =>
                                    this.handleValueChange(event, 'ctaIva')
                                }
                            />
                        </Tooltip>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <Tooltip
                            title="Fecha de inicio de validez del IVA y cuentas"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            {/* <TextField
                                id={'fIni'}
                                label={'Fecha Inicio'}
                                placeholder={'Fecha Inicio'}
                                type="date2"
                                value={this.state.fIni}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={(event) => this.handleValueChange(event, 'fIni')}
                            /> */}
                            <DatePicker
                                label={'Fecha Inicio'}
                                value={this.state.fIni}
                                onChange={event => {
                                    if (event && !isNaN(event)) {
                                        const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                        this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fIni')
                                    }
                                }}
                            />
                        </Tooltip>
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <Tooltip
                            title="Fecha de de fin de validez del IVA y cuentas (vacío indica sin límite)"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            {/* <TextField
                id={"fEnd"}
                label={"Fecha Fin"}
                placeholder={"Fecha Fin"}
                type="date2"
                value={this.state.fEnd}
                InputLabelProps={{
                  shrink: true
                }}
                onChange={event => this.handleValueChange(event, "fEnd")}
              /> */}
                            <DatePicker
                                label={'Fecha Fin'}
                                value={this.state.fEnd}
                                onChange={event => {
                                    if (event && !isNaN(event)) {
                                        const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                        this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fEnd')
                                    }
                                    else{
                                        this.handleValueChangeDate(null, 'fEnd')
                                    }
                                }}
                            />
                        </Tooltip>
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="secondary"
                        onClick={() => this.props.hideDialog()}
                    >
                        Cerrar
                    </Button>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            const contab = {
                                id: this.state.id,
                                iTipoMaquina: this.state.iTipoMaquina,
                                tipoMaquina: this.state.tipoMaquina,
                                zonaIva: this.state.zonaIva,
                                iTipoZonaIva: this.state.iTipoZonaIva,
                                ctaDebe: this.state.ctaDebe,
                                ctaHaber: this.state.ctaHaber,
                                ctaIva: this.state.ctaIva,
                                fIni: this.state.fIni,
                                fEnd: this.state.fEnd,
                                centroId: this.props.centroid,
                            };

                            if (this.props.checkContab(contab)) {
                                this.props.okHandler(contab);
                                this.props.hideDialog();
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </div>
        );
    }
}

EditContabCentro.propTypes = {
    contabCentro: PropTypes.object.isRequired,
    tiposMaquina: PropTypes.array.isRequired,
    tiposZonaIva: PropTypes.array.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkContab: PropTypes.func.isRequired,
    centroid: PropTypes.number.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditContabCentro);
